<script lang="ts">
  interface Props {
    onHide: () => void;
    onBlock: () => void;
    onReport: () => void;
  }

  let { onHide, onBlock, onReport }: Props = $props();
  let open = $state(false);

  function close() { open = false; }

  function pick(action: () => void) {
    close();
    action();
  }
</script>

<div class="relative">
  <button
    type="button"
    class="p-2 rounded-md hover:bg-gray-100 dark:hover:bg-dark-tertiary text-content-tertiary"
    aria-label="대화 메뉴"
    onclick={() => (open = !open)}
  >
    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 5v.01M12 12v.01M12 19v.01" />
    </svg>
  </button>

  {#if open}
    <button
      type="button"
      class="fixed inset-0 z-10 cursor-default"
      aria-label="메뉴 닫기"
      onclick={close}
    ></button>
    <div class="absolute right-0 top-full mt-1 z-20 w-44 rounded-md border border-default bg-white dark:bg-dark-secondary shadow-lg py-1">
      <button type="button" class="w-full text-left px-3 py-2 text-body2 hover:bg-gray-50 dark:hover:bg-dark-tertiary" onclick={() => pick(onHide)}>
        대화 숨기기
      </button>
      <button type="button" class="w-full text-left px-3 py-2 text-body2 hover:bg-gray-50 dark:hover:bg-dark-tertiary text-error" onclick={() => pick(onBlock)}>
        사용자 차단
      </button>
      <div class="my-1 border-t border-default"></div>
      <button type="button" class="w-full text-left px-3 py-2 text-body2 hover:bg-gray-50 dark:hover:bg-dark-tertiary" onclick={() => pick(onReport)}>
        신고하기
      </button>
    </div>
  {/if}
</div>
